import { Alert, Button } from "@/atoms";
import { AlertVariantEnum, ButtonVariantEnum } from "@/enums";

import { AuthHeader } from "./auth-header";

export const AuthInvalidState = ({
    actionLabel,
    message,
    onAction,
    title,
}: {
    actionLabel: string,
    message: string,
    onAction: () => void,
    title: string,
}) => (
    <div>
        <AuthHeader title={title} />
        <Alert
            className="mb-6"
            variant={AlertVariantEnum.ERROR}
        >{message}</Alert>
        <Button
            variant={ButtonVariantEnum.LINK}
            onClick={onAction}
        >{actionLabel}</Button>
    </div>
);
